import React from 'react'
import RightArrow from 'react-icons/lib/ti/arrow-right'

export default () => (
  <div className="examples-pane">
    <div className="pane-title">See it in action</div>
    <div className="example">
      <div className="source">
        <img
          src="https://v.embed-cdn.com/homepage/cbs-logo-inv.png"
        />
      </div>
      <img
        src="https://v.embed-cdn.com/homepage/cbs-screenshot.jpg"
      />
      <div className="title">
        World Series: Nats Force Game 7
      </div>
      <a
        href="https://www.cbssports.com/mlb/news/astros-vs-nationals-score-washington-forces-world-series-game-7-as-stephen-strasburg-stifles-houston/live/"
      >
        View on CBSSports.com <RightArrow />
      </a>
    </div>
    <div className="example">
      <div className="source">
        <img
          src="https://v.embed-cdn.com/homepage/kt-logo.png"
        />
      </div>
      <img
        src="https://v.embed-cdn.com/homepage/kt-screenshot.jpg"
      />
      <div className="title">Halo Wars 2: The Kotaku Review</div>
      <a href="https://kotaku.com/halo-wars-2-the-kotaku-review-1792373382">
        View on Kotaku.com <RightArrow />
      </a>
    </div>
    <div className="example">
      <div className="source">
        <img src="https://v.embed-cdn.com/homepage/bi-logo-inv.png" />
      </div>
      <img
        src="https://v.embed-cdn.com/homepage/bi-screenshot.jpg"
      />
      <div className="title">
        BI Report: Alexa Echo Dot In A Car
      </div>
      <a
        href="https://www.businessinsider.com/using-amazon-echo-dot-in-a-car-2017-7"
      >
        View on BusinessInsider.com <RightArrow />
      </a>

    </div>
  </div>
)
